import React from "react";
import styles from "./WorkingScheduleCard.module.css"
import {WorkingHoursUi} from "../../../../../../../../api/generated";
import classnames from "classnames";

interface LocationDetailsProps {
    title: string
    workingHours: WorkingHoursUi
}

export const WorkingScheduleCard: React.FC<LocationDetailsProps> = ({
                                                                        title,
                                                                        workingHours
                                                                    }) => {
    const isClosed = workingHours.isClosed

    const formatTime = (time: any) => {
        const [timeHour, timeMinute] = String(time).split(":")

        return `${timeHour}:${timeMinute}`
    }

    return <div className={classnames(styles.wrapper, workingHours.isClosed && styles.closed)}>
        <span className={styles.title}>{title}</span>
        <span className={styles.time}>{isClosed ? "" : formatTime(workingHours.openTime)}</span>
        <span className={styles.time}>{isClosed ? "" : formatTime(workingHours.closeTime)}</span>
    </div>
}
